import BasePage from '../../components/base-page/base-page';
import Carousel from '../../components/carousel/carousel';

import type { UiElement } from '../../../shared/ui-element/ui-element';

import breakpoints from '../../config/breakpoints';

import './reviews.scss';

class Reviews extends BasePage {

  testimonialsCarousel;

  onInit() {
    super.onInit();

    this.testimonialsCarousel = new Carousel({
      rootElement: this.ui.testimonialsCarousel,
      slidesPerPage: {
        [breakpoints.sm]: 2,
        [breakpoints.lg]: 3,
      },
    });

    this.testimonialsCarousel.init();
  }
}
export default Reviews;

(Reviews as UiElement).initOnDomLoaded();
